import React from "react";
import { FixedSizeList } from "react-window";
import { Autocomplete, TextField, Checkbox, MenuItem } from "@mui/material";

const VirtualizedAutocomplete = ({
  skillData,
  searchData,
  setSearchData,
  fieldStyle,
}) => {
  // Wrapper to ensure click events propagate correctly
  const renderVirtualizedList = React.forwardRef(function ListboxComponent(
    props,
    ref
  ) {
    const { children, ...rest } = props;

    return (
      <div ref={ref} {...rest}>
        <FixedSizeList
          height={300} // Adjust dropdown height
          width="100%"
          itemSize={46} // Height of each item
          itemCount={children.length}
        >
          {({ index, style }) =>
            React.cloneElement(children[index], {
              style: { ...style, top: `${style.top}px` },
              onMouseDown: (event) => {
                // Prevent closing on click
                event.preventDefault();
              },
            })
          }
        </FixedSizeList>
      </div>
    );
  });

  return (
    <Autocomplete
      multiple
      id="virtualized-autocomplete"
      options={skillData?.locations || []}
      disableCloseOnSelect
      value={
        skillData?.locations?.filter((skl) =>
          searchData.skill_ids?.includes(skl.id)
        ) || []
      }
      onChange={(event, value) => {
        // Update state on selection
        const selectedSkillIds = value.map((skl) => skl?.id);
        setSearchData((prev) => ({
          ...prev,
          skill_ids: selectedSkillIds,
        }));
      }}
      getOptionLabel={(option) => option?.name || ""}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <Checkbox checked={selected} sx={{ marginRight: 0, marginLeft: 0 }} />
          <span>{option?.name}</span>
        </MenuItem>
      )}
      ListboxComponent={renderVirtualizedList} // Use virtualized list
      renderInput={(params) => (
        <TextField
          {...params}
          label="Skills"
          variant="standard"
          size="small"
          name="skill_ids"
          sx={fieldStyle}
        />
      )}
      sx={{ backgroundColor: "#fff", width: "100%" }}
    />
  );
};

export default VirtualizedAutocomplete;
